<template>
  <TopGradientBlockLayout>
    <template #top>
      <CreateAPISession v-if="isFormOpen" @token-created="handleNewTokenCreate"/>
      <BaseButton v-else
                  theme="red"
                  class="w-91 mr-12"
                  @click="isFormOpen = true">
        {{ $t('addToken') }}
      </BaseButton>
    </template>
    <APITokensList @update-list="fetchTokenList"/>
    <ModalPreviewToken v-if="previewToken.show"
                       :token="previewToken.value"
                       @close="clearPreview"/>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import {mapActions} from "vuex";
import CreateAPISession from "@/components/cabinet/ProfileSettings/APISettings/CreateAPIToken";
import APITokensList from "@/components/cabinet/ProfileSettings/APISettings/APITokensList";
import ModalPreviewToken from "@/components/cabinet/ProfileSettings/APISettings/ModalPreviewToken";

export default {
  name: "TheAPISettings",
  components: {ModalPreviewToken, APITokensList, CreateAPISession, BaseButton, TopGradientBlockLayout},
  data() {
    return {
      isFormOpen: false,
      previewToken: {
        show: false,
        value: null
      }
    }
  },
  methods: {
    ...mapActions('space/apiTokens', ['fetchTokenList']),
    handleNewTokenCreate(token) {
      this.previewToken.show = true;
      this.previewToken.value = token;
      this.isFormOpen = false;
      this.fetchTokenList();
    },
    clearPreview() {
      this.previewToken.show = false;
      this.previewToken.value = null;
    }
  },
  async mounted() {
    await this.fetchTokenList()
  },
  i18n: {
    messages: {
      en: {
        addToken: 'Add token'
      },
      ru: {
        addToken: 'Добавить токен'
      }
    }
  }
}
</script>

<style scoped>

</style>